var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiDataConnections = function SvgApiDataConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "api_data_connections_svg2__a",
    x1: 3.65,
    x2: 212.63,
    y1: 166.57,
    y2: 20.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__b",
    x1: 3.65,
    x2: 212.63,
    y1: 166.57,
    y2: 20.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__c",
    x1: -2.31,
    x2: 206.67,
    y1: 158.06,
    y2: 11.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__d",
    x1: 3.59,
    x2: 212.57,
    y1: 166.48,
    y2: 20.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__e",
    x1: 11.98,
    x2: 220.96,
    y1: 178.46,
    y2: 32.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__f",
    x1: -0.06,
    x2: 208.92,
    y1: 161.26,
    y2: 14.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__g",
    x1: -53.6,
    x2: 155.38,
    y1: 84.79,
    y2: -61.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__h",
    x1: 60.51,
    x2: 269.48,
    y1: 247.79,
    y2: 101.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__i",
    x1: 8.46,
    x2: 217.44,
    y1: 173.44,
    y2: 27.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__j",
    x1: 14.83,
    x2: 223.81,
    y1: 182.54,
    y2: 36.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__k",
    x1: 2.72,
    x2: 211.7,
    y1: 165.24,
    y2: 18.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_data_connections_svg2__a",
    id: "api_data_connections_svg2__l",
    x1: -3.95,
    x2: 205.03,
    y1: 155.71,
    y2: 9.43
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m144.61 164.92 19.1-19.1-7.55-10.55c3.77-6.11 6.5-12.71 8.15-19.66l12.79-2.11V86.48l-12.79-2.11a66.8 66.8 0 0 0-8.15-19.66l7.55-10.55-19.1-19.1-10.55 7.55a69 69 0 0 0-6.6-3.58l-2.5 5.3c4.16 1.97 6.72 3.69 9.27 5.37l9.75-6.98 12.07 12.07-6.98 9.75c5.12 7.77 7.98 13.45 10.35 24.96l11.82 1.95v17.08l-11.82 1.95c-1.86 9.05-3.85 15.08-10.35 24.96l6.98 9.75-12.07 12.07-9.75-6.98c-7.77 5.12-13.45 7.98-24.96 10.35l-1.95 11.82H90.24l-1.95-11.82c-9-1.85-15.04-3.82-24.96-10.35l-9.75 6.98-12.07-12.07 6.98-9.75c-5.1-7.75-7.97-13.42-10.35-24.96l-11.82-1.95V91.45l11.82-1.95c1.87-9.08 3.86-15.1 10.35-24.96l-6.98-9.75 12.07-12.07 9.75 6.98c7.73-5.09 13.39-7.97 24.96-10.35l1.95-11.82h17.08l1.95 11.82c3.17.65 5.91 1.18 10.09 2.67l1.97-5.52c-2.25-.8-4.57-1.49-6.92-2.05l-2.11-12.79H85.28l-2.11 12.79a66.8 66.8 0 0 0-19.66 8.15l-10.55-7.55-19.1 19.1 7.55 10.55a66.6 66.6 0 0 0-8.15 19.66l-12.79 2.11v27.02l12.79 2.11a66.8 66.8 0 0 0 8.15 19.66l-7.55 10.55 19.1 19.1 10.55-7.55c6.11 3.77 12.7 6.5 19.66 8.15l2.11 12.79h27.02l2.11-12.79a66.8 66.8 0 0 0 19.66-8.15l10.55 7.55Z",
    style: {
      fill: "url(#api_data_connections_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.44 99.99c0 10.76 3.9 21.13 10.99 29.21l4.41-3.86a38.4 38.4 0 0 1-9.53-25.35c0-21.21 17.26-38.47 38.47-38.47s38.47 17.26 38.47 38.47-17.26 38.47-38.47 38.47c-9.2 0-18.1-3.3-25.07-9.29l-3.82 4.44c8.03 6.9 18.29 10.7 28.89 10.7 24.45 0 44.33-19.89 44.33-44.33s-19.89-44.33-44.33-44.33-44.33 19.89-44.33 44.33Z",
    style: {
      fill: "url(#api_data_connections_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.08 115.21V84.55H70.54v30.66h5.86v-10.93h8.82v10.93zm-5.86-16.8H76.4v-8h8.82z",
    style: {
      fill: "url(#api_data_connections_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35 84.55H95.81v30.66h5.86v-11.14h14.68V84.56Zm-5.86 13.65h-8.82v-7.79h8.82z",
    style: {
      fill: "url(#api_data_connections_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.16 84.77h5.86v30.44h-5.86z",
    style: {
      fill: "url(#api_data_connections_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35 0c-7.75 0-14.05 6.3-14.05 14.05 0 6.74 4.77 12.39 11.12 13.74v42.94h-3.17v5.86h9.03v-48.8c6.34-1.35 11.12-7 11.12-13.74C190.4 6.3 184.1 0 176.35 0m0 22.24c-4.52 0-8.19-3.67-8.19-8.19s3.67-8.19 8.19-8.19 8.19 3.67 8.19 8.19-3.67 8.19-8.19 8.19",
    style: {
      fill: "url(#api_data_connections_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 28.1c6.66 0 12.24-4.66 13.68-10.88h30.1v11.93h5.86v-17.8H37.89C36.63 4.89 30.93 0 24.1 0c-7.75 0-14.05 6.3-14.05 14.05S16.35 28.1 24.1 28.1m0-22.24c4.52 0 8.19 3.67 8.19 8.19s-3.67 8.19-8.19 8.19-8.19-3.67-8.19-8.19 3.67-8.19 8.19-8.19",
    style: {
      fill: "url(#api_data_connections_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76 171.9c-6.93 0-12.71 5.05-13.84 11.66h-29.94v-12.09h-5.86v17.95h36.03c1.55 6.07 7.07 10.57 13.61 10.57 7.75 0 14.05-6.3 14.05-14.05s-6.3-14.05-14.05-14.05Zm0 22.24c-4.52 0-8.19-3.67-8.19-8.19s3.67-8.19 8.19-8.19 8.19 3.67 8.19 8.19-3.67 8.19-8.19 8.19",
    style: {
      fill: "url(#api_data_connections_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.58 172.21v-41.77h1.18v-5.86h-7.04v47.63c-6.34 1.35-11.12 7-11.12 13.74 0 7.75 6.3 14.05 14.05 14.05s14.05-6.3 14.05-14.05c0-6.74-4.77-12.39-11.12-13.74m-2.93 21.93c-4.52 0-8.19-3.67-8.19-8.19s3.67-8.19 8.19-8.19 8.19 3.67 8.19 8.19-3.67 8.19-8.19 8.19",
    style: {
      fill: "url(#api_data_connections_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.83 99.99c0-8.96-2.11-17.67-6.19-25.59l-5.21 2.68a49.9 49.9 0 0 1 5.54 22.91z",
    style: {
      fill: "url(#api_data_connections_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.32 67.87c1.18 1.41 2.29 2.9 3.31 4.44l4.88-3.24a55 55 0 0 0-3.7-4.95l-4.5 3.76Z",
    style: {
      fill: "url(#api_data_connections_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35 60.2a53 53 0 0 1 4.19 3.61l4.06-4.22a56 56 0 0 0-4.68-4.03l-3.58 4.64Z",
    style: {
      fill: "url(#api_data_connections_svg2__l)"
    }
  }));
};
export default SvgApiDataConnections;